(function(angular){
	'use strict';

	angular
		.module('imageLazyModule')
		.directive('lazySrc', [
			'BREAKPOINTS', 
			'RevealService', 
			'$window',
			lazySrcFunction
		]);

	function lazySrcFunction(BREAKPOINTS, RevealService, $window) {
		return {
			restrict: 'A',
			scope: {
				autoLoad: '@',
				lazySrc: '@'
			},
			link: {
				pre: function(scope, elem) {
					elem.addClass('fade');
				},
				post: function(scope, elem) {
					var isLoaded = false;
					var image = new Image();

					var loadImage = function(src) {
						if (elem[0].tagName !== 'IMG') {
							elem.css('background-image', 'url("' + src + '")');
						} else {
							image = elem[0];
						}
						image.src = src;

						image.onload = function() {
							elem.addClass('in');
							scope.$emit('lazyImage:loaded');
						};
					};

					var determineCorrectMultiSrc = function() {
						var sources = scope.lazySrc.split(',');
						var sourceParsed = {};

						angular.forEach(sources, function(source) {
							source = source.trim();
							
							var lastThreeLetters = source.slice(-3);

							if(lastThreeLetters.indexOf('_sm') >= 0) {
								sourceParsed.sm = source.slice(0,-3);
							} else if(lastThreeLetters.indexOf('_md') >= 0) {
								sourceParsed.md = source.slice(0,-3);
							} else if(lastThreeLetters.indexOf('_lg') >= 0) {
								sourceParsed.lg = source.slice(0,-3);
							} else {
								sourceParsed.default = source;
							}
						});

						if($window.innerWidth >= BREAKPOINTS.MD_START && $window.innerWidth < BREAKPOINTS.LG_START) {
							loadImage(sourceParsed.md || sourceParsed.default);
						} else if($window.innerWidth >= BREAKPOINTS.LG_START) {
							loadImage(sourceParsed.lg || sourceParsed.md || sourceParsed.default);
						} else {
							loadImage(sourceParsed.sm || sourceParsed.default);
						}
					};

					var checkIfImageShouldBeLoaded = function () {
						if (!isLoaded && scope.lazySrc !== '' && RevealService.isTopOfElementInViewport(elem[0], 150) && scope.autoLoad !== 'false') {
							isLoaded = true;
							angular.element($window).off('scroll', checkIfImageShouldBeLoaded);

							if(scope.lazySrc.indexOf(',') === -1) {
								loadImage(scope.lazySrc);
							} else {
								determineCorrectMultiSrc();
							}
						}
					};

					angular.element($window).on('scroll', checkIfImageShouldBeLoaded);
					scope.$on('runLazyLoad', checkIfImageShouldBeLoaded);
					scope.$on('updateLazyLoad', function() {
						isLoaded = false;
						elem.removeClass('in');
						checkIfImageShouldBeLoaded();
					});
					scope.$watch('autoLoad', function() {
						checkIfImageShouldBeLoaded();
					});

					checkIfImageShouldBeLoaded();
				}
			}
		};
	}
})(window.angular);